var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exhibition"},[_c('img',{attrs:{"src":this.url,"alt":""}}),_vm._v(" "),_c('router-link',{staticClass:"exhibitionBut",attrs:{"to":"/home","tag":"div"}},[_vm._v("点击进入报告")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-342bd742","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/exhibition.vue
// module id = null
// module chunks = 